import { studioBOn } from './flag';

/** Studio B's tokens under the host variable names the storyboard kit reads (sb-kit tokens.ts SB_HOST_VARS). */
const LENT: [hostVar: string, token: string][] = [
  ['--color-background-primary', '--b-panel'],
  ['--color-background-secondary', '--b-raised'],
  ['--color-background-tertiary', '--b-line-solid'],
  ['--color-border-tertiary', '--b-line'],
  ['--color-text-primary', '--b-text-1'],
  ['--color-text-secondary', '--b-text-2'],
];

/**
 * Direction B (beta only): the surfaces and text the storyboard page borrows (sb:host style), read for the current
 * theme, so the page reads as one of the studio's panels: B's panel for its ground and its cards raised.
 * Shared links get none and keep the kit's own look.
 */
export function studioBHostStyle(root: HTMLElement = document.documentElement): Record<string, string> | null {
  if (!studioBOn()) return null;
  const css = getComputedStyle(root);
  const style: Record<string, string> = {};
  for (const [hostVar, token] of LENT) {
    const value = css.getPropertyValue(token).trim();
    if (value) style[hostVar] = `hsl(${value})`;
  }
  return Object.keys(style).length ? style : null;
}
